(() => {
  const mq = window.matchMedia("(max-width: 749px)");

  const init = () => {
    const layout = document.querySelector(".iurop-product__layout");
    if (!layout) return;
    const gallery = layout.querySelector("cooldo-broth-gallery");
    const info = layout.querySelector(".iurop-product__info");
    if (!gallery || !info) return;

    let top = layout.querySelector(".ig-pdp-top");

    const apply = () => {
      if (mq.matches) {
        if (!top) {
          top = document.createElement("div");
          top.className = "ig-pdp-top";
          layout.insertBefore(top, gallery);
        }
        let metaRow = top.querySelector(".ig-pdp-top__meta");
        if (!metaRow) {
          metaRow = document.createElement("div");
          metaRow.className = "ig-pdp-top__meta";
          top.appendChild(metaRow);
        }

        const title = info.querySelector(".iurop-product__title") || top.querySelector(".iurop-product__title");
        const rating = info.querySelector(".iurop-product__rating") || metaRow.querySelector(".iurop-product__rating");
        const price = info.querySelector(".iurop-product__price") || metaRow.querySelector(".iurop-product__price");
        const badges = info.querySelector(".iurop-product__badges") || top.querySelector(".iurop-product__badges");

        if (title) top.insertBefore(title, metaRow);
        if (rating) metaRow.appendChild(rating);
        if (price) metaRow.appendChild(price);
        if (badges) top.appendChild(badges);
      } else if (top && top.children.length) {
        const measure = info.querySelector(".iurop-product__measure");
        const badges = top.querySelector(".iurop-product__badges");
        const rating = top.querySelector(".iurop-product__rating");
        const title = top.querySelector(".iurop-product__title");
        const price = top.querySelector(".iurop-product__price");
        [badges, rating, title, price].forEach((el) => {
          if (el && measure) info.insertBefore(el, measure);
        });
      }
    };

    apply();
    mq.addEventListener("change", apply);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
